import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getRoles } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
class RoleAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            permissions: [],
            formData: {
                name: '',
                selectedPermissions: [],
            },
            loading: false,
            isLoad: true,
            expandedCategories: {},
        }
    }
    async componentDidMount() {
        this.getPermissions();
    }

    setRoles = async () => {
        const roles = await getRoles();
        localStorage.setItem('roles', JSON.stringify(roles));
    }
    getPermissions = async () => {
        const response = await apiCall('business/settings/role/get-permissions', 'get', null);
        this.setState({ permissions: response }, () => {
            this.setState({ isLoad: false })
        })
    }
    handleChance = (e) => {
        const { id, value } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: value
            }
        }))
    }
    handleCheckboxChange(permissionId, isChecked) {

        const { formData } = this.state;
        if (isChecked) {
            this.setState({
                formData: {
                    ...formData,
                    selectedPermissions: [...formData.selectedPermissions, permissionId]
                }
            });
        } else {
            this.setState({
                formData: {
                    ...formData,
                    selectedPermissions: formData.selectedPermissions.filter(id => id !== permissionId)
                }
            });
        }
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;

        try {
            const response = await apiCall('business/settings/role/add', 'post', formData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message)
        } catch (e) {
            this.setState({ loading: false });
        }
    }
    toggleCategory = (category) => {
        this.setState(prevState => ({
            expandedCategories: {
                ...prevState.expandedCategories,
                [category]: !prevState.expandedCategories[category],
            }
        }));
    }
    render() {
        const { permissions, loading, expandedCategories } = this.state;
        const { userPermissions } = this.props;
        const userHasNewRolePermission = userPermissions.includes('new role');
        const groupedPermissions = {};
        permissions.forEach(permission => {
            if (!groupedPermissions[permission.category]) {
                groupedPermissions[permission.category] = [];
            }
            groupedPermissions[permission.category].push(permission);
        });
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}>
                <div>
                    <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
                        <div className="loader"
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="m-t-30">
                                <img src={require('../../assets/images/logo-white.png')} width="150"
                                    alt="Lucid" />
                            </div>
                            <p>Yükleniyor</p>
                            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
                        </div>
                    </div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Servis durumu ekle"
                            Breadcrumb={[
                                { name: "Yetkiler", navigate: "settings/roles" },
                                { name: "Yeni yetki", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="body">
                                            <div className="row clearfix justify-content-center">
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <input
                                                            id="name"
                                                            className="form-control"
                                                            placeholder="Yetki adı"
                                                            type="text"
                                                            onChange={this.handleChance}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="body">
                                            <div className="row clearfix">
                                                <ul className="list-unstyled feeds_widget col-lg-12">
                                                    {Object.keys(groupedPermissions).map((category, index) => (
                                                        <li key={index} style={{ padding: 30, margin: 15 }}>
                                                            <div className="feeds-left">
                                                                <i className={`fa ${expandedCategories[category] ? 'fa-chevron-down text-cyan' : 'fa-chevron-right text-cyan'}`}
                                                                    onClick={() => this.toggleCategory(category)}></i>
                                                            </div>
                                                            <div className="feeds-body">
                                                                <h4 className="title"
                                                                    onClick={() => this.toggleCategory(category)}
                                                                    style={{ cursor: 'pointer' }}>
                                                                    {category}
                                                                </h4>
                                                                {expandedCategories[category] && (
                                                                    <div className="d-flex flex-wrap mt-5">
                                                                        {groupedPermissions[category].map(permission => (
                                                                            <div className="fancy-checkbox mr-3"
                                                                                key={permission.id}>
                                                                                <label>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        onChange={(e) => this.handleCheckboxChange(permission.id, e.target.checked)}
                                                                                    />
                                                                                    <span>{permission.permission_name}</span>
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="body">
                                            <div className="row clearfix justify-content-center">
                                                <div className="col-lg-6 col-md-12">

                                                    {loading ? (
                                                        <button className="btn btn-outline-primary btn-block"
                                                            disabled={true}
                                                            style={{ textAlign: "-webkit-center" }}>
                                                            Lütfen Bekleyin...<ReactLoading type="spin"
                                                                width={'24px'}
                                                                height={'24px'}
                                                                color="#268bd2"></ReactLoading>
                                                        </button>
                                                    ) :
                                                        <button disabled={!userHasNewRolePermission} className="btn btn-outline-primary btn-block"
                                                            type="submit">
                                                            Kaydet
                                                        </button>}
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(RoleAdd)));
